import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'humand-banner',
  templateUrl: './humand-banner.component.html',
  styleUrls: ['./humand-banner.component.scss']
})
export class HumandBannerComponent {
  humandUrl = environment.humandUrl;
}
